<template>
    <v-col
        v-if="availableDirections.length > 1"
        cols="12"
        class="pa-0"
        ref="colsp"
    >
      <v-item-group
          v-model="chosenDirection"
          mandatory
      >
        <div
            class="d-flex justify-content-around"
        >
          <template v-for="(dir, indx) in availableDirections">
            <v-item
                v-slot="{ active, toggle }"
                :key="'col-' + indx"
                :value="dir.serviceName"
            >
              <v-tooltip
                  bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-img
                      v-bind="attrs"
                      v-on="on"
                      @click="toggle"
                      :src="dir.icon"
                      :width="itemW"
                      max-height="70"
                      contain
                  >
                    <div
                        v-if="active"
                        class="fill-height repeating-gradient"
                        style="background-color: rgba(48,48,48,0.26)"
                    ></div>
                  </v-img>
                </template>
                <span>{{ dir.name }}</span>
              </v-tooltip>
            </v-item>
          </template>
        </div>
      </v-item-group>
      <v-select
          v-show="false"
          v-model="chosenDirection"
          :items="availableDirections"
          item-text="name"
          item-value="serviceName"
          class="pt-0 pb-2 px-0"
          solo
          dense
          hide-details
      />
      <v-dialog
          v-model="addInfoModal"
          max-width="600"
          persistent
      >
        <v-card>
          <v-card-title>
            Уточнить данные
          </v-card-title>
          <v-card-text>
            <div class="row">
              <div class="col">
                <div class="auto-options max-371 d-flex flex-column radio-toolbar">
                  <div
                      class="form-group d-flex justify-content-around"
                      :class="{ 'error-border' : inputErrors.diskType}"
                  >
                    <div class="radio-toolbar d-flex justify-content-between">
                      <input type="radio" id="radioAlloy" name="radioDiskType" value="alloy" v-model="diskType">
                      <label data-test-id="radioDiskTypeAlloy" for="radioAlloy">
                        <div class="btn btn-options__models__icon">
                          <img :src="require('@/assets/images/icons/alloy.png')" alt="литой">
                        </div>
                      </label>

                      <input type="radio" id="radioShtamp" name="radioDiskType" value="shtamp" v-model="diskType">
                      <label for="radioShtamp" data-test-id="radioDiskTypeStamp">
                        <div class="btn btn-options__models__icon">
                          <img :src="require('@/assets/images/icons/shtamp.png')" alt="штампованный">
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="form-group d-flex justify-content-center">
                    <div class="radio-toolbar d-flex flex-wrap justify-content-between">
                      <input
                          v-model="frameVehicle"
                          type="checkbox"
                          id="radioFrameVehicle"
                          name="radioFrameVehicle"
                          value="frameVehicle"
                      >
                      <label for="radioFrameVehicle">
                        <div class="btn btn-options__models__icon runflat">
                                <span class="font-size-16 font-italic">
                                  Рамный автомобиль
                                </span>
                          <br/>
                          <span class="font-size-10 font-italic border-top pt-1">
                                  или профиль от 70 и выше
                                </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="radio-toolbar d-flex flex-wrap justify-content-between">
                    <template v-for="(item) in configDisks">
                      <input :key="`input-${item.value}`" type="radio" :id="item.value" name="radioTyreSize" :value="item.value" v-model="diskSize">
                      <label :key="`label${item.value}`" :for="item.value" :data-test-id="`radioDiskSize${item.value}`">
                        <div class="btn btn-options__models__icon">
                          <span class="font-size-24">{{ item.text }}</span>
                        </div>
                      </label>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-content-around">
            <v-btn @click="checkAndClose">
              сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
</template>

<script>
const configDisks = [
  {
    value: 'R12',
    text: 'R12'
  },
  {
    value: 'R13',
    text: 'R13'
  },
  {
    value: 'R14',
    text: 'R14'
  },
  {
    value: 'R15',
    text: 'R15'
  },
  {
    value: 'R16',
    text: 'R16'
  },
  {
    value: 'R17',
    text: 'R17'
  },
  {
    value: 'R18',
    text: 'R18'
  },
  {
    value: 'R19',
    text: 'R19'
  },
  {
    value: 'R20',
    text: 'R20'
  },
  {
    value: 'R21',
    text: 'R21'
  },
  {
    value: 'R22',
    text: 'R22'
  },
  {
    value: 'R23',
    text: 'R23'
  },
  {
    value: 'R24',
    text: 'R24'
  }
]

export default {
  name: 'directionsChange',
  // mounted() {
  //   const ww = this.$refs.colsp.clientWidth
  //   this.itemW = ww / this.availableDirections.length
  // },
  computed: {
    availableDirections () {
      return this.$store.state.login.availableDirections
    },
    chosenDirection: {
      get () {
        return this.$store.state.login.chosenDirection
      },
      set (newVal) {
        if (newVal !== 'additional' && !this.$store.getters.chosenMark && !this.$store.getters.chosenModel) {
          this.$store.commit('login/setChosenDirection', newVal)
          this.$router.push('/order/clientcard')
        } else {
          this.$store.commit('login/setChosenDirection', newVal)
        }
      }
    },
    diskType: {
      get () {
        return this.$store.getters.diskType
      },
      set (value) {
        this.$store.commit('updateDiskType', value)
      }
    },
    runflat: {
      get () {
        return this.$store.getters.runflat
      },
      set (value) {
        this.$store.commit('updateRunflat', value)
      }
    },
    frameVehicle: {
      get () {
        return this.$store.getters.frameVehicle
      },
      set (value) {
        this.$store.commit('updateFrameVehicle', value)
      }
    },
    diskSize: {
      get () {
        return this.$store.getters.diskSize
      },
      set (value) {
        this.$store.commit('updateDiskSize', value)
      }
    },
    itemW ()  {
      return  100/this.availableDirections.length + '%'
    }
  },
  watch: {
    chosenDirection (newVal) {
      if (newVal === 'tireFitting' && this.diskType === '' && this.diskSize === '') {
        this.addInfoModal = true
      }
    },
  },
  data () {
    return {
      configDisks,
      inputErrors: {
        carMark: false,
        selectedPlate: false,
        carType: false,
        diskType: false,
        diskSize: false,
        name: false,
        phone: false
      },
      addInfoModal: false,
    }
  },
  methods: {
    checkAndClose () {
      if (this.diskType !== '' && this.diskSize !== '') {
        this.addInfoModal = false
      }
    },
  }
}
</script>

<style scoped>
.btn {
  margin: 0.375rem;
  color: inherit;
  text-transform: uppercase;
  word-wrap: break-word;
  white-space: normal;
  cursor: pointer;
  border: 0;
  border-radius: 0.125rem;
  -webkit-box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  -webkit-transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;
  padding: 0.84rem 2.14rem;
  font-size: .81rem;
}
.radio-toolbar input[type="radio"], input[type="checkbox"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

.radio-toolbar label {
  display: inline-block;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 15px;
}

.btn-options__models__icon {
  display: table-cell;
  padding: 10px;
  width: 5vw;
  height: 6vh;
  border-radius: 15px;
  vertical-align: middle;
}
.radio-toolbar input[type="radio"]:focus + label, input[type="checkbox"]:checked  + label {
  border-radius: 15px;
}

.radio-toolbar input[type="radio"]:checked + label>div, input[type="checkbox"]:checked + label>div {
  background-color: #fffbcd;
  box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, .4);
}
.btn-custom {
  margin: 0;
  width: 259px;
  height: 56px;
  font-family: "Istok Web Regular";
  font-size: 20px;
  color: #4a4a4a;
  border: 1px solid #ced4da;
  border-radius: 11px;
  background-color: #e8ffcf;
  text-transform: none;
}
</style>